export enum SearchReportType {
  DossierSearchResultsReport = 'DossierSearchResultsReport',
  ReferenceDataActivityType = 'ReferenceDataActivityType',
  ReferenceDataImParameter = 'ReferenceDataImParameter',
  ReferenceDataLocoType = 'ReferenceDataLocoType',
  ReferenceDataOperationPoint = 'ReferenceDataOperationPoint'
}
